module.exports = __webpack_public_path__ + "media/lesson/fonts/Frutiger/FrutigerRoman-4104823da7ccf62f22b2e02609a72f9b.woff";